import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-primary-600 z-40 whitespace-nowrap"
      aria-label="Scroll to top"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}